import { readTable } from '../store/localDb.store'
import type { LocalRow } from '../types/localDb.types'

const idOf = (value: unknown) =>
  typeof value === 'object' && value !== null ? String((value as { id?: unknown }).id ?? '') : String(value ?? '')

/**
 * Rak gudang satelit Sansugi (`mt_warehouses.kind = SGI`) dikelola di Master Lokasi Gudang (MST-06), tetapi bukan bagian
 * dari peta putaway, pendataan awal, opname, dan dashboard WH RM. Setiap handler RM membaca rak/bin lewat helper ini.
 */
export function satelliteRackIds(): Set<string> {
  const warehouses = new Set(
    readTable('mt_warehouses')
      .filter(row => row.kind === 'SGI')
      .map(row => String(row.id))
  )
  if (!warehouses.size) return new Set()
  const zones = new Set(
    readTable('warehouse_zone')
      .filter(row => warehouses.has(idOf(row.warehouse_id)))
      .map(row => String(row.id))
  )
  return new Set(
    readTable('mt_rack')
      .filter(row => zones.has(idOf(row.zone_id)))
      .map(row => String(row.id))
  )
}

export const racksOfRm = (): LocalRow[] => {
  const satellite = satelliteRackIds()
  return readTable('mt_rack').filter(row => !satellite.has(String(row.id)))
}

export const binsOfRm = (): LocalRow[] => {
  const satellite = satelliteRackIds()
  return readTable('mt_rack_bin').filter(row => !satellite.has(idOf(row.rack_id)))
}
